import React from 'react';

const DashCardHeader = ({ children, title, description, iconClass }) => {
    return (
        <div className="card border-0 shadow-sm" style={{ borderRadius: 18, overflow: "hidden" }}>
            <div
                className="d-flex align-items-center justify-content-between"
                style={{
                padding: "16px 18px",
                borderBottom: "1px solid rgba(15,23,42,.06)",
                background: "linear-gradient(180deg, rgba(79,70,229,.06), rgba(255,255,255,0))",
                }}
            >
                <div className="d-flex align-items-center" style={{ gap: 12 }}>
                {iconClass && <div className="card-icon">
                    <i className={iconClass} />
                </div>}

                <div>
                    <div style={{ fontWeight: 900, color: "#0F172A", fontSize: 14.5 }}>{title}</div>
                    <div style={{ color: "rgba(71,85,105,.85)", fontSize: 12 }}>{description}</div>
                </div>
                </div>
            </div>

      <div className="card-body" style={{ padding: 18 }}>
        {children}
      </div>
    </div>
  );
};

export default DashCardHeader;